<template>
  <section id="footer">
    <div class="list">
      <router-link
        :to="item.route"
        v-for="item in navigation"
        :key="item.name"
        class="item"
        :class="[item.name, { selected: route && route.includes(item.name) }]"
      >
        <div class="name">{{ $t(item.title) }}</div>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      route: "",
      navigation: [
        {
          route: "/",
          name: "home",
          title: "miclive.navigation.home"
        },
        {
          route: "/competition",
          name: "competition",
          title: "miclive.navigation.competition"
        },
        {
          route: "/live",
          name: "live",
          title: "miclive.navigation.live"
        },
        {
          route: "/follow",
          name: "follow",
          title: "miclive.navigation.follow"
        }
      ]
    };
  },
  computed: {},
  methods: {},
  mounted() {
    this.route = this.$route.name;
  },
  watch: {
    "$route.name": {
      handler: function(value) {
        this.route = value;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
#footer {
  width: 100%;
  bottom: 0px;
  background-color: $main-color;
  position: fixed;
  height: 50px;

  color: #fff;

  .list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    max-width: 1000px;
    margin: 0 auto;

    .item {
      background-position: center top 7px;
      background-repeat: no-repeat;
      background-size: 20px;
      text-decoration: none;
      color: #fff;
      text-align: center;
      transition: all 0.3s;

      .name {
        padding-top: 30px;
        font-size: 0.7rem;
        text-transform: uppercase;
      }

      &.home {
        background-image: url("~@/../public/img/home.svg");
      }
      &.competition {
        background-image: url("~@/../public/img/competition.svg");
      }
      &.live {
        background-image: url("~@/../public/img/live.svg");
      }
      &.follow {
        background-image: url("~@/../public/img/follow.svg");
      }

      &.selected,
      &:hover {
        transition: all 0.3s;
        font-family: $font-title;
        color: $secondary-color;
        &.home {
          background-image: url("~@/../public/img/home_sel.svg");
        }
        &.competition {
          background-image: url("~@/../public/img/competition_sel.svg");
        }
        &.live {
          background-image: url("~@/../public/img/live_sel.svg");
        }
        &.follow {
          background-image: url("~@/../public/img/follow_sel.svg");
        }
      }
    }
  }
}
</style>
